module.exports = __webpack_public_path__ + "img/healthcheck-head-long@2x@2x.95fa5538.png";